// @flow

export const MODEL = 'Recommendations'
export const TREE = 'recommendationsData'
export const BRANCH = 'recommendations'
export const OPERATIONS_TREE = 'recommendationsModule'
export const OPERATIONS_BRANCH = 'operations'

// Api End Point
export const URL = 'hefty/recommendation/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_RECOMMENDATION_ID = PROP_ID
export const PROP_YIELD_TARGET = 'yield_target'
export const PROP_CONTROLLER_TYPE = 'controller_type'
export const PROP_REMOVAL_CROP_GROWN = 'removal_crop_grown'
export const PROP_REMOVAL_YIELD = 'removal_yield'
export const PROP_RECOMMENDATION_TYPE = 'recommendation_type'
export const PROP_TARGET_PH = 'target_pH'
export const PROP_PREVIOUS_CROP = 'previous_crop'
export const PROP_CREDIT_OTHER_PRESCRIPTIONS = 'credit_other_prescriptions'
export const PROP_STATUS = 'status'
export const PROP_RXRATES = 'rxRates'
export const PROP_ASSET = 'asset'
export const PROP_CROP = 'crop'
export const PROP_REMOVAL_CROP = 'removal_crop'
export const PROP_CONTROLLER = 'controller'
export const RECOMMENDATION_FERTILIZER_SET = 'recommendationfertilizer_set'
// Recommendation Fertilizer Properties
export const PROP_PRESCRIPTION_ID = 'id'
export const PROP_COST_PER_ACRE = 'cost_per_acre'
export const PROP_COST_PER_TON = 'cost_per_ton'
export const PROP_MAX_RATE = 'max_rate'
export const PROP_MIN_RATE = 'min_rate'
export const PROP_MIN_RATE_TYPE = 'min_rate_type'
export const PROP_FERTILIZER = 'fertilizer'
export const PROP_ADJUSTMENT_TYPE = 'adjustment_type'
export const PROP_ADJUSTMENT_VALUE = 'adjustment_value'
export const PROP_ELEMENT_PICK = 'element_pick'
export const PROP_ELEMENT_SPLIT = 'element_split'
export const PROP_PERCENT_SPLIT = 'percent_split'
export const PROP_TANK_NUMBER = 'tankNumber'

// controller types
export const NONE = 'None (PDF Only)'
export const AG_LEADER_TGT = 'Ag Leader - TGT'
export const AG_LEADER_AGSETUP = 'Ag Leader - .agsetup'
export const AG_LEADER_IRX = 'Ag Leader IRX'
export const CNH_VOYGER_2 = 'CNH Voyager 2'
export const FALCON_VT = 'Falcon VT'
export const GREEN_STAR_SHAPE_FILE = 'GreenStar ShapeFile'
export const MID_TECH_LEGACY = 'Mid-Tech/Legacy'
export const SEED_SENSE_20_20 = 'Seed Sense 20/20'
export const SHAPE_FILE = 'ShapeFile'
export const TIFF_FILE = 'TIFF File'
export const VIPER = 'Viper'

export const CONTROLLER_TYPES = [
  NONE,
  AG_LEADER_TGT,
  AG_LEADER_AGSETUP,
  AG_LEADER_IRX,
  CNH_VOYGER_2,
  FALCON_VT,
  GREEN_STAR_SHAPE_FILE,
  MID_TECH_LEGACY,
  SEED_SENSE_20_20,
  SHAPE_FILE,
  TIFF_FILE,
  VIPER,
]

// recommendation types
export const AG_PHD_MAINTENANCE = {
  value: 'Ag PhD Maintenance',
  label: 'Maintenance',
}
export const AG_PHD_BUILD_BALANCE = {
  value: 'Ag PhD Build+Balance',
  label: 'Build+Balance',
}

export const RECOMMENDATION_TYPES = {
  AG_PHD_MAINTENANCE,
  AG_PHD_BUILD_BALANCE,
}

export const BOTH = 'Both'
export const UNSUPPORTED = 'Unsupported'

// previous crops
export const ALFALFA = 'Alfalfa'
export const PEANUTS = 'Peanuts'
export const SOYBEANS = 'Soybeans'

export const PREVIOUS_CROPS = [ALFALFA, PEANUTS, SOYBEANS]

// status
export const FARM_COMMAND = 'FARM_COMMAND'
export const FERT_CALC = 'FERT_CALC'
export const PATRICIA = 'PATRICIA'
export const AG_INTEGRATED = 'AG_INTEGRATED'
export const COMPLETE = 'COMPLETE'
export const STATUS = [FARM_COMMAND, FERT_CALC, PATRICIA, AG_INTEGRATED, COMPLETE]

// min rate types
export const STANDARD = 'Standard'
export const MACHINE = 'Machine'
export const NON_ZERO = 'Non-Zero'

export const MIN_RATE_TYPES = [STANDARD, MACHINE, NON_ZERO]

// adjustment types
export const ADJ_PERCENT = 'Percent'
export const ADJ_PRODUCT_RATE = 'Product Rate'
export const ADJ_ELEMENT = 'Element (lbs/ac) Manure'

export const ADJUSTMENT_TYPES = [ADJ_PERCENT, ADJ_PRODUCT_RATE, ADJ_ELEMENT]

// error handling constants
export const MAX_SHOULD_BE_GREATER_THAN_MIN = 'MAX_SHOULD_BE_GREATER_THAN_MIN'
export const VALUE_SHOULD_BE_GREATER_THAN_ZERO = 'VALUE_SHOULD_BE_GREATER_THAN_ZERO'

// meta
export const ELEMENT_SPLIT_TYPE = 'ELEMENT_SPLIT_TYPE'
